import "./finOffers/finOffersCtrl";
import "./finOffers/rankingCtrl";
import "./compareController";
import "./finOffers/robotaCtrl";
import "./finOffers/educationCtrl";



// WEBPACK FOOTER //
// src/js/controllers/offers/index.js